export default function createDraggableScroll() {
    const state = {
        isDragging: false,
        startX: 0,
        scrollLeft: 0
    };

    function initDraggableScroll(element) {
        if (!element) {
            return;
        }

        const styles = {
            cursor: 'grab',
            userSelect: 'none',
            overflow: 'auto',
            whiteSpace: 'nowrap'
        };

        Object.assign(element.style, styles);

        function startDragging(e) {
            state.isDragging = true;
            element.style.cursor = 'grabbing';
            state.startX = e.pageX - element.offsetLeft;
            state.scrollLeft = element.scrollLeft;
        }

        function drag(e) {
            if (!state.isDragging) return;

            e.preventDefault();
            const walk = (e.pageX - element.offsetLeft - state.startX) * 2;
            element.scrollLeft = state.scrollLeft - walk;
        }

        function stopDragging() {
            state.isDragging = false;
            element.style.cursor = 'grab';
        }

        element.addEventListener('mousedown', startDragging);
        element.addEventListener('mousemove', drag);
        element.addEventListener('mouseup', stopDragging);
        element.addEventListener('mouseleave', stopDragging);

        return function cleanup() {
            element.removeEventListener('mousedown', startDragging);
            element.removeEventListener('mousemove', drag);
            element.removeEventListener('mouseup', stopDragging);
            element.removeEventListener('mouseleave', stopDragging);
        };
    }

    return {
        initDraggableScroll
    };
}
